module.exports = __webpack_public_path__ + "static/media/model-pajero-00-lwb.8e3ee9a2.jpg";